import { memo, useEffect } from 'react';
import { noop } from 'lodash';
import { useFormik } from 'formik';
// Import Types
import type { CJCascadeDropdownProps } from 'components/CustomerJourney/CJCascadeDropdown';
// Import Components
import { CJCascadeDropdown } from 'components/CustomerJourney';

interface Props extends CJCascadeDropdownProps {
    defaultValue?: AnyObject;
    getUpdate: (update: AnyObject) => void;
}

const SameDayForm: React.FC<Props> = ({ defaultValue, getUpdate, ...rest }) => {
    const formik = useFormik({
        initialValues: { property: defaultValue?.property || {} },
        onSubmit: noop,
    });
    const { values, setFieldValue } = formik;
    const { property } = values;

    const cascadeDropdownChangeHandler = ({ parentValue, value, logicFunction }) => {
        getUpdate({ property: { parentValue, value, logicFunction } });
        setFieldValue('property', { parentValue, value, logicFunction });
    };

    useEffect(() => {
        getUpdate({ property });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <CJCascadeDropdown
                onChange={cascadeDropdownChangeHandler}
                value={{ ...property }}
                onValidationChange={(isValid) => getUpdate({ isValid })}
                {...rest}
            />
        </>
    );
};

export default memo(SameDayForm);
